/**
 * Page2 Component
 *
 * This component returns a page that contains a detailed description of the second item in the project list.
 */

import React from "react";

const Page2 = () => {
  return (
    <div className="page-content">
      <h2>Title 2</h2>
      <p>Additional content for the second item.</p>
    </div>
  );
};

export default Page2;
